import React, { Component } from 'react'
import ReactDOM from 'react-dom'

class BackLink extends Component{
    
   render(){
        const {backLink, domNode} = this.props
        let node = document.getElementById(domNode)

        return ReactDOM.createPortal(
            backLink,
            node
        );
   }

}

export default BackLink


// WEBPACK FOOTER //
// ./src/components/BackLink.js